import script from "./resource-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./resource-dialog.vue?vue&type=script&setup=true&lang=js"

import "./resource-dialog.vue?vue&type=style&index=0&id=455a0b67&lang=scss&scoped=true"
import "./resource-dialog.vue?vue&type=style&index=1&id=455a0b67&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-455a0b67"]])

export default __exports__